<div class="pag-container">

    <app-campaign-3-breadcrumb
        #breadcrumbComponent
        [arrayBreadcrumbs]="breadcrumbs"
        (onClickBreadcrumb)="breadcrumbClicked($event)"
        homeLink="">
    </app-campaign-3-breadcrumb>

    <div class="ui-g-12 vertical-margin-20">
        <div class="ui-g-6 no-lateral-padding">
            <h1 class="title">{{ 'distributionList.distributionList_creation' | translate }}</h1>
        </div>
        
        <div class="ui-g-6 d-flex justify-content-end">
            <button class="btn-page-act" style="margin-right: 10px;" (click)="onBackAction()">
                <i class="pi pi-arrow-left margin-fit"></i>

                <span>{{ 'distributionList.back' | translate }}</span>
            </button>
            <button class="btn-page-act" (click)="onSaveDistributionList()">
                <i class="pi pi-save margin-fit"></i>

                <span>{{ 'distributionList.save' | translate }}</span>
            </button>
        </div>
    </div>

    <div class="ui-g-12">
        <h2 class="title">{{ 'distributionList.save' | translate }}</h2>
    </div>

    <div class="ui-g-12 vertical-margin-10 no-lateral-padding">
        <div class="ui-g-6">
            <div class="ui-g-12 no-lateral-padding">
                <app-form-fields
                    #distributionList_name
                    [(fieldModel)]="fieldModel.name"
                    [type]="'string'"
                    [label]="'distributionList.list_name' | translate"
                    [name]="'name'" 
                    [optionLabel]="'name'"
                    [placeholder]="'distributionList.list_name' | translate"
                    [required]="true">
                </app-form-fields>
            </div>
            <div class="ui-g-12 no-lateral-padding align-items-center" style="margin-top: 40px;">
                <app-form-fields
                    #previewList 
                    [readOnly]="readOnly"
                 
                    [type]="'switch'"
                    [(fieldModel)]="fieldModel.previewList">
                </app-form-fields>
                <span>{{  'distributionList.preview_list' | translate }}</span>
            </div>
        </div>

        <div class="ui-g-6" style="margin-top: 5px;">
            <app-form-fields
                #distributionList_description
                [(fieldModel)]="fieldModel.description"
                [required]="false"
                [type]="'textarea'"
                [label]="'distributionList.list_description' | translate"
                [name]="'description'" 
                [optionLabel]="'description'"
                [placeholder]="'campaign.enter_distribution_description' | translate">
            </app-form-fields>
        </div>
    </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/distribution-list/edit-create-distribution-list-3/edit-create-distribution-list-3.component.html